var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMachineTarget = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "#FC557C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FC557C"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.012 6.667c0 .158-.103.288-.23.288H9.218c-.126 0-.229-.13-.229-.288 0-.159.103-.288.23-.288h1.565c.126 0 .229.129.229.288m-.23-1.111H9.218c-.487 0-.884.498-.884 1.11 0 .613.397 1.112.884 1.112h1.566c.487 0 .884-.499.884-1.111 0-.613-.397-1.111-.884-1.111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.274 7.886c0-.012.01-.023.023-.023h.672v2.065c0 1.727 1.36 3.133 3.031 3.133s3.031-1.406 3.031-3.133V7.863h.673c.012 0 .022.01.022.023v7.068c0 .012-.01.023-.022.023H6.297a.023.023 0 0 1-.023-.023V7.886zm6.039 2.042c0 1.318-1.038 2.39-2.313 2.39-1.275 0-2.312-1.072-2.312-2.39l.002-3.561c.05-1.285 1.065-2.29 2.31-2.29 1.275 0 2.313 1.071 2.313 2.39v3.46zM7.925 15.72a.328.328 0 0 1-.301.204.328.328 0 0 1-.3-.204h.6zm4.451.204a.328.328 0 0 1-.3-.204h.601a.328.328 0 0 1-.3.204zm1.328-8.804h-.673v-.654c0-1.727-1.36-3.133-3.031-3.133S6.969 4.74 6.969 6.466v.654h-.672a.755.755 0 0 0-.741.766v7.068c0 .422.332.766.74.766h.29c.064.533.505.947 1.038.947s.974-.414 1.038-.947h2.676c.064.533.505.947 1.038.947s.974-.414 1.039-.947h.289c.408 0 .74-.344.74-.766V7.886a.755.755 0 0 0-.74-.766z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMachineTarget, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/machine_target.cf12828a.svg";
export { ForwardRef as ReactComponent };